export type CheckoutFooterAction = 'back' | 'processing' | 'complete';

/**
 * Which action the embedded Checkout step offers.
 *
 * The three states are sequential: the customer is still in the form, the money has arrived but
 * the webhook has not marked the event paid yet, or both are done. They were previously three
 * overlapping ternary conditions, which made `processing` unreachable and left a paying customer
 * looking at a `Back` button.
 */
export const getCheckoutFooterAction = (
  isSessionComplete: boolean,
  isEventPaid: boolean,
): CheckoutFooterAction => {
  if (!isSessionComplete) return 'back';
  if (!isEventPaid) return 'processing';
  return 'complete';
};
